import { CircularProgress, Dialog, DialogContent, DialogTitle, Typography, makeStyles } from '@material-ui/core'
import FileUpload from 'components/form_components/fileUpload'
import React, { useEffect, useState } from 'react'



const useStyles = makeStyles((theme) => ({
    dialog: {
        "& .MuiDialog-paperWidthMd": {
            boxShadow: "0px 3px 6px #00000029",
            // position: "absolute",
            // left: "calc(50% - 250px)",
            width: '40%',
            height: '238px',
            borderRadius: '5px'
        }
    },
    dialogTitle: {
        color: theme.palette.primary.main,
        fontSize: '18px'
    }

}))

function Files(props) {
    const classes = useStyles()
    const { handleClose, currentSelection, name } = props
    const [loading, setLoading] = useState(false)
    const [files, setFiles] = useState([])


    useEffect(() => {
        setFiles(currentSelection)
    }, [currentSelection])



    return (
        <div>
            <Dialog
                // fullWidth={true}
                maxWidth={'md'}
                open={true}
                onClose={handleClose}
                className={classes.dialog}
                aria-labelledby="dispatch-files">

                <DialogTitle ><Typography variant='subtitle2' className={classes.dialogTitle}>{name} </Typography> </DialogTitle>
                <DialogContent>

                    <FileUpload
                        isLoading={loading}
                        defaultValue={files !== undefined ? files.map((file) => ({
                            filename: file?.filename ? file?.filename : file?.file_name,
                            url: file?.url ? file?.url : file?.file_path,
                            id: file?.id,
                        })) : ''}
                        APIUrl={""}
                        showBorderOnNoFiles={true}
                        uploadButtonView={true}
                        multiple={true}
                        name={"maintenance_file"}
                        action={"Upload Document"} />

                </DialogContent>
            </Dialog>

        </div>
    )
}

export default Files